import loadable from '@react-loadable/revised';
import LoadingComponent from 'common/loader';
import type { ApplicationRoute } from 'routes/routes';

const routes: ApplicationRoute[] = [
    {
        path: '/settings',
        exact: true,
        auth: true,
        component: loadable({
            loader: () => import('./pages/list/SettingsListPage').then((m) => m.default),
            loading: LoadingComponent,
        }),
    },
    {
        path: '/settings/:code',
        exact: true,
        auth: true,
        component: loadable({
            loader: () => import('./pages/edit/SettingEditPage').then((m) => m.default),
            loading: LoadingComponent,
        }),
    },
];
export default routes;
